/* =========================================================================
   Stable-code mapping shared by the game client and the telemetry backend.
   Prototype/demo questions (client ids < 2001) use the "proto-<id>" codes
   seeded by db/seed/002; the hard pack (ids 3001..3093) uses "hard3-NNN"
   codes seeded by db/008, db/013, and db/021 (3001 -> hard3-001, zero-padded
   to three digits). The Leo XIV / 2026 current-events medium pack (ids
   2001..2999) uses "leo14-NNN" codes seeded by db/021 (2001 -> leo14-001).
   Keep this in lockstep with those seed scripts.
   ========================================================================= */
export function stableCodeFor(id: number): string {
  if (id >= 3001) return `hard3-${String(id - 3000).padStart(3, '0')}`;
  if (id >= 2001 && id <= 2999) return `leo14-${String(id - 2000).padStart(3, '0')}`;
  return `proto-${id}`;
}
